import axios from 'axios'
import store from '@/cache/store'

function token() {
  let auth = store.getters.getAuth
  if (!auth.token && localStorage.hasOwnProperty('token'))
    auth.token = localStorage.token

  return auth.token
}

export default() => {
  return axios.create({
    headers: {'Authorization': token()},
    // baseURL: `http://localhost:3000`
    baseURL: `https://beta.royalexperience.net`
  })
}